// @ts-strict-ignore
import React, { FC } from 'react'
import { Button, Grid, GridRow, GridCol, Header, Toolbar, ToolbarButtons } from '@mytours/components'
import strings from '../../../../strings'
import '@google/model-viewer'

interface FullscreenArProps {
	usdz?: string
	glb?: string
	onClose?: () => void
	filename?: string
}

const FullscreenAr: FC<FullscreenArProps> = ({ usdz, glb, onClose, filename }) => (
	<Grid className="fullscreen-video-container">
		<GridRow className="fullscreen-video-row">
			<GridCol>
				<GridRow className="header-row">
					<Header className="header fullscreen-video-header">
						<Toolbar className="header-toolbar">
							<ToolbarButtons slot="end" className="header-buttons">
								<Button
									variant="clear"
									className="back-button"
									onClick={onClose}
									player-action-attribute="player-action-attribute"
									aria-label={strings.accessibility_go_back}
								>
									<i className="fal fa-xmark close-icon" />
								</Button>
							</ToolbarButtons>
						</Toolbar>
					</Header>
				</GridRow>
				<GridRow className="player-row" style={{ zIndex: 100 }}>
					{/* @ts-ignore */}
					<model-viewer src={glb} ios-src={usdz} alt={filename} ar={true} auto-rotate={true} camera-controls={true} />
				</GridRow>
			</GridCol>
		</GridRow>
	</Grid>
)

export default FullscreenAr
